import { createRouter, createWebHistory } from 'vue-router'
const routes = []
const router = createRouter({
  // hash: createWebHashHistory(),
  history: createWebHistory(),
  routes: routes,
})

export default router
